import { site, testimonials } from "@/mocks/chiagua";

const stats = [
  { num: "12.8万+", label: "已收录神评论", icon: "ri-quote-text" },
  { num: "860期", label: "名场面合集", icon: "ri-clapperboard-line" },
  { num: "320万", label: "吃瓜小伙伴", icon: "ri-group-line" },
  { num: "每日", label: "持续更新热梗", icon: "ri-flashlight-line" },
];

export default function About() {
  return (
    <section id="about" className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-start">
          <div>
            <p className="font-heading text-2xl text-primary-500 md:text-3xl">👋 关于围观星球</p>
            <h2 className="mt-2 text-2xl font-black text-foreground-950 md:text-4xl">一群爱看评论区的快乐编辑部</h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              大家好，这里是<strong className="font-bold text-foreground-900">{site.brand}</strong>。我们相信，一条视频的笑点有七成藏在评论区里——
              那些被赞上天的神评、让人拍案的名场面、一看到就想转发的沙雕热评和吃瓜梗图，才是真正的快乐富矿。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              所以，我们每天在各大平台的评论区"蹲守"，把高能热评和出圈名场面筛选、归纳成清爽的合集。
              无论你是想找素材、找乐子，还是单纯想找个"同好"，都能在 <strong className="font-bold text-foreground-900">围观星球</strong> 找到属于你的专区。
            </p>
            <ul className="mt-6 space-y-3 text-sm text-foreground-700">
              <li className="flex items-start gap-3">
                <i className="ri-emotion-happy-line mt-0.5 text-lg text-accent-600" aria-hidden="true"></i>
                <span><strong className="font-bold">认真选品</strong>：只收真正好笑、真正出圈的，拒绝硬凑与烂梗。</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-file-list-3-line mt-0.5 text-lg text-accent-600" aria-hidden="true"></i>
                <span><strong className="font-bold">尊重原创</strong>：尽量保留出处语境，版权归原作者，本站仅做收集与展示。</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-rocket-line mt-0.5 text-lg text-accent-600" aria-hidden="true"></i>
                <span><strong className="font-bold">每日上新</strong>：热评榜与名场面基本每日更新，帮你接住每一波新梗。</span>
              </li>
            </ul>
          </div>

          {/* 数据墙 + 口碑 */}
          <div>
            <dl className="grid grid-cols-2 gap-4">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-2xl border border-background-200 bg-background-50 p-5"
                >
                  <dt className="order-2 mt-1 text-xs text-foreground-500 md:text-sm">{s.label}</dt>
                  <dd className="order-1 flex items-center gap-2">
                    <i className={`${s.icon} text-accent-600`} aria-hidden="true"></i>
                    <span className="font-heading text-2xl text-foreground-950 md:text-3xl">{s.num}</span>
                  </dd>
                </div>
              ))}
            </dl>

            <h3 className="mt-7 text-base font-black text-foreground-950 md:text-lg">吃瓜小伙伴怎么说</h3>
            <div className="mt-4 grid gap-3 sm:grid-cols-2">
              {testimonials.map((t) => (
                <figure key={t.id} className="rounded-2xl border border-background-200 bg-background-50 p-4">
                  <blockquote className="text-sm leading-relaxed text-foreground-700">“{t.text}”</blockquote>
                  <figcaption className="mt-3 flex items-center gap-2.5">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-200 font-heading text-secondary-700">
                      {t.name.slice(0, 1)}
                    </span>
                    <div>
                      <p className="text-sm font-bold text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}